import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
/* src/app/page.mypage/view.scss: no such file or directory */`],
})
export class PageMypageComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public info = {};
    public password = {};

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("마이페이지 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { data } = await wiz.call("session");
        this.info = data.user;

        try {
            if (this.info.birth) this.info.birth = moment(this.info.birth).format("YYYY-MM-DD");
        } catch (e) {
            user.birth = null;
        }

        await this.service.render();
    }

    public async update() {
        let userinfo = JSON.stringify(this.info);
        const { code, data } = await wiz.call("update", { userinfo });
        if (code != 200) {
            return await this.service.alert.error("저장에 실패했습니다.");
        } else {
            await this.service.alert.success("저장되었습니다");
            await this.load();
            return;
        }
    }

    public async changePassword() {
        let pdata = JSON.parse(JSON.stringify(this.password));

        if (pdata.data != pdata.repeat) return await this.service.alert.error("변경 비밀번호를 다시 확인해주세요");

        let pd = {};
        pd.current = this.service.auth.hash(pdata.current);
        pd.data = this.service.auth.hash(pdata.data);

        const { code, data } = await wiz.call("change_password", pd);

        if (code != 200) return await this.service.alert.error(data);

        await this.service.alert.success("변경되었습니다. 다시 로그인해주세요.");
        location.href = "/auth/logout";
    }
}

export default PageMypageComponent;